import type { WorkflowRunStatus } from '@erp/workflows';

/**
 * Run statuses that mean work is still in flight. The complement —
 * `completed`, `failed`, `cancelled`, `terminated`, `review` — is terminal.
 */
export const ACTIVE_WORKFLOW_RUN_STATUSES: ReadonlySet<WorkflowRunStatus> =
  new Set<WorkflowRunStatus>(['scheduled', 'queued', 'running', 'idle']);

export function isActiveWorkflowRunStatus(
  status: string | null | undefined,
): boolean {
  return (
    status != null &&
    ACTIVE_WORKFLOW_RUN_STATUSES.has(status as WorkflowRunStatus)
  );
}

/** How often an entity surface re-reads a run that is still in flight. */
export const ACTIVE_WORKFLOW_RUN_POLL_MS = 5_000;
